function SearchIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      fill="none"
      viewBox="0 0 15 15"
    >
      <path
        fill="#EC6726"
        d="M3.726 9.4a5.688 5.688 0 111.222 1.223h.001a1.025 1.025 0 01-.086.1l-3.369 3.37a.875.875 0 01-1.238-1.237l3.37-3.37a.88.88 0 01.1-.087zM3.5 6.036a4.813 4.813 0 109.626 0 4.813 4.813 0 00-9.626 0z"
      ></path>
    </svg>
  );
}

export default SearchIcon;
